export const getCalendarEventLocation = (
  pathname: string,
): { basePath: string; eventId?: string } => {
  const match = pathname.match(/^(.*)\/events\/([^/]+)\/?$/);
  if (match?.[1] && match[2]) {
    return { basePath: match[1], eventId: match[2] };
  }
  return { basePath: pathname.replace(/\/$/, "") };
};
